import { useLanguage } from "@/context/LanguageContext";
import { Reveal } from "@/components/Reveal";

export const Manifesto = () => {
  const { t } = useLanguage();

  return (
    <section id="manifesto" className="mx-auto max-w-[1600px] px-4 py-24 sm:px-8 sm:py-32 lg:px-16" data-testid="manifesto-section">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-accent sm:text-sm">{t.manifesto.eyebrow}</p>
        <h2 className="mt-4 font-display text-3xl font-extrabold uppercase tracking-tight text-ink sm:text-5xl">
          {t.manifesto.title}
        </h2>
      </Reveal>

      <div className="mt-20 space-y-0">
        {t.manifesto.chapters.map((chapter, i) => (
          <Reveal key={chapter.num} delay={0.05}>
            <div
              className={`grid grid-cols-1 gap-6 border-t border-white/10 py-14 md:grid-cols-12 md:items-baseline ${i % 2 === 1 ? "" : ""}`}
              data-testid={`manifesto-chapter-${chapter.num}`}
            >
              <span className="font-display text-6xl font-extrabold leading-none text-outline-accent sm:text-7xl md:col-span-3">
                {chapter.num}
              </span>
              <h3 className="font-display text-2xl font-extrabold uppercase tracking-tight text-ink sm:text-3xl md:col-span-4">
                {chapter.heading}
              </h3>
              <p className="text-base leading-relaxed text-mist md:col-span-5 sm:text-lg">{chapter.body}</p>
            </div>
          </Reveal>
        ))}
        <div className="border-t border-white/10" />
      </div>
    </section>
  );
};
